// AJM Aviation wordmark — the winged "AJM" emblem + "AJM AVIATION" lockup.
// Height scales with the surrounding font-size (use text-lg / text-2xl etc.).
export function Logo({ className = '' }: { className?: string }) {
  return (
    <span className={`inline-flex items-center ${className}`} aria-label="AJM Aviation">
      <img
        src={`${import.meta.env.BASE_URL}ajm-logo.png`}
        alt="AJM Aviation"
        className="h-[1.5em] w-auto select-none"
        draggable={false}
      />
    </span>
  );
}
